import Tooltips from "./tooltip";
import React from "react";

const IconHover = React.forwardRef(({ onClick, additionalclasses, children, ...props }, ref) => {
    return (
        <Tooltips position={props.position || ''} content={props.content} command={props.command}>
            <div onClick={onClick} className={`${additionalclasses} hover:custom-bg-grey-50 rounded-[4px] transtion-all duration-300 w-fit cursor-pointer px-[5px] py-[5px]`} ref={ref}>
                {children}
            </div>
        </Tooltips>
    );
});

IconHover.displayName = "IconHover";

export default IconHover;